export const FEATURE_STATUS = {
  ALL: "",
  NO: 0,
  YES: 1,
  COMING_SOON: 2,
};

export const featureStatusLabels = {
  [FEATURE_STATUS.YES]: "Yes",
  [FEATURE_STATUS.NO]: "No",
  [FEATURE_STATUS.COMING_SOON]: "Coming Soon",
};

export const featureStatusIconLabels = {
  [FEATURE_STATUS.YES]: "✅",
  [FEATURE_STATUS.NO]: "❌",
  [FEATURE_STATUS.COMING_SOON]: "⏳",
};

export const featureStatusFormOptions = [
  { value: FEATURE_STATUS.YES, label: featureStatusLabels[FEATURE_STATUS.YES] },
  { value: FEATURE_STATUS.NO, label: featureStatusLabels[FEATURE_STATUS.NO] },
  { value: FEATURE_STATUS.COMING_SOON, label: featureStatusLabels[FEATURE_STATUS.COMING_SOON] },
];

export const featureStatusFilters = [
  { value: FEATURE_STATUS.ALL, label: "All" },
  { value: FEATURE_STATUS.YES.toString(), label: featureStatusLabels[FEATURE_STATUS.YES] },
  { value: FEATURE_STATUS.NO.toString(), label: featureStatusLabels[FEATURE_STATUS.NO] },
  { value: FEATURE_STATUS.COMING_SOON.toString(), label: featureStatusLabels[FEATURE_STATUS.COMING_SOON] },
];
